import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map, Observable, throwError } from 'rxjs';
import { DOCUMENT_DEFAULT_LANG, DOCUMENT_LABELS } from '../constans';
import {
  GenericDocument,
  SpvOldResponse,
  SpvResponse,
} from '../document.interface';

type SpvOldKeys = 'certificado' | 'consulado' | 'orden' | 'contrato';

@Injectable({
  providedIn: 'root',
})
export class SpvDocumentsService {
  private hashCode: string;

  constructor(private http: HttpClient) {
    this.hashCode = '';
  }

  search(numberCertificate: number): Observable<GenericDocument> {
    return this.http
      .get<SpvResponse[]>(
        `${environment.server.spv.url}/api/services/app/TravelInsuranceRequest/GetTravelInsuranceRequestByPurchaseNumber`,
        {
          params: {
            Query: `${numberCertificate}`,
            QueryType: 4,
          },
          headers: {
            Authentication: environment.server.spv.token,
          },
        }
      )
      .pipe(
        map((data) => data[0] as SpvResponse),
        map((data) => {
          this.hashCode = data.hashCode ?? '';
          return this.setDocuments(data, DOCUMENT_DEFAULT_LANG, data.pax);
        })
      );
  }

  searchOld(
    numberCertificate: number,
    birthDate: string
  ): Observable<GenericDocument> {
    return this.http
      .post<SpvOldResponse>(
        `${environment.server.spv.urlOld}/Consulta/Certificado`,
        {
          lang: 'ESP',
          ncompra: numberCertificate,
          fecha_nacimiento: birthDate,
        }
      )
      .pipe(
        map((data) => {
          if (data.err) throw throwError(() => new Error(data.mensaje));

          return data;
        }),
        map(this.generateOldDocument)
      );
  }

  private setDocuments(
    customer: SpvResponse,
    lang?: string,
    index?: number
  ): GenericDocument {
    const documentTypes = [
      'Certificate',
      'Consulate',
      'PurchaseOrder',
      'Contract',
      'Certificate',
    ];
    const items = DOCUMENT_LABELS.map((label, i) => ({
      label,
      link: this.getUrlDocument(documentTypes[i], index ?? 1, lang),
    }));

    if (!customer.petId) {
      items.splice(-1);
    }

    return {
      items,
    };
  }

  private getUrlDocument(doc: string, pax: number, lang?: string): string {
    let language = '';

    if (lang && lang !== 'es') {
      language = `&language=_${lang}`;
    }

    return `${environment.server.spv.url}/api/Documents/${doc}?pax=${pax}&code=${this.hashCode}&tenantId=2${language}`;
  }

  private generateOldDocument(data: SpvOldResponse): GenericDocument {
    const cols: SpvOldKeys[] = [
      'certificado',
      'consulado',
      'orden',
      'contrato',
    ];

    return {
      items: cols.map((c, i) => ({
        label: DOCUMENT_LABELS[i],
        link: data[c],
      })),
    };
  }
}
